import { render, staticRenderFns } from "./Sermons.vue?vue&type=template&id=a7e1ac9c&"
import script from "./Sermons.vue?vue&type=script&lang=js&"
export * from "./Sermons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports